<template>
  <b-container class="my-3 my-md-5">
    <b-row>
      <b-col md="12">
        <b-card>
          <b-card-body>
            <h4 class="card-heading mb-4">Datev Export</h4>

              <b-form-group label="Monat">
                <b-form-select v-model="form.month" :options="months" />
              </b-form-group>

              <b-form-group label="Jahr">
                <b-form-select v-model="form.year" :options="years" />
              </b-form-group>

              <b-form-group>
                <b-button type="submit" variant="primary" class="float-right" @click="submitForm">
                Exportieren <b-spinner small v-if="requestInProgress"></b-spinner>
                </b-button>
              </b-form-group>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <modal-error-component v-model="modalError"></modal-error-component>
  </b-container>
</template>

<script>
export default {
  name: 'DatevIndex',
  data() {
    return {
      form: {
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
      },
      months: [
        { value: 1, text: 'Januar' },
        { value: 2, text: 'Februar' },
        { value: 3, text: 'März' },
        { value: 4, text: 'April' },
        { value: 5, text: 'Mai' },
        { value: 6, text: 'Juni' },
        { value: 7, text: 'Juli' },
        { value: 8, text: 'August' },
        { value: 9, text: 'September' },
        { value: 10, text: 'Oktober' },
        { value: 11, text: 'November' },
        { value: 12, text: 'Dezember' },
      ],
      years: [],
      requestInProgress: false,
      modalError: {
        show: false,
        message: '',
        error: '',
        title: ''
      },
    };
  },
  created() {
    const currentYear = new Date().getFullYear();
    const startYear = 2021;
    this.years = Array.from({ length: currentYear - startYear + 1 }, (v, k) => startYear + k);
  },
  methods: {
    submitForm() {
      this.requestInProgress = true;
      axios.post('/datevexport', this.form)
        .then(response => {
          this.requestInProgress = false;
          console.log('Export erfolgreich!', response);

          const blob = new Blob([response.data], { type: 'text/csv' });

          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = 'datev_export-'+ this.form.year + '-'+ this.form.month +'.csv'; // You can customize the filename

          link.click();
        })
        .catch(error => {
          this.requestInProgress = false;
          this.modalError = {
            show: true,
            message: 'Ein Fehler ist aufgetreten',
            error: error.response?.data?.message ?? error.response?.data ??  error.message ?? error,
            title: 'Erstellen fehlgeschlagen'
          };
        });
    },
  },
};
</script>